import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

const styles = {
  primary: "bg-navy text-white hover:bg-navy-deep",
  gold: "bg-gold text-navy hover:bg-gold-light",
  ghost: "border border-navy/25 text-navy hover:border-navy hover:bg-navy hover:text-white",
  ghostLight: "border border-white/35 text-white hover:bg-white hover:text-navy",
};

export const Btn = ({ to, href, children, variant = "primary", className = "", testId, ...rest }) => {
  const cls = `btn-sheen group relative inline-flex items-center justify-center gap-3 overflow-hidden rounded-full px-6 py-3.5 text-sm font-semibold tracking-wide transition-[background-color,color,border-color,transform] duration-300 active:scale-[0.98] ${styles[variant]} ${className}`;
  const inner = (
    <>
      <span className="relative">{children}</span>
      <ArrowUpRight className="relative h-4 w-4 shrink-0 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
    </>
  );
  if (href) return <a href={href} className={cls} data-testid={testId} {...rest}>{inner}</a>;
  return <Link to={to} className={cls} data-testid={testId} {...rest}>{inner}</Link>;
};
